export const Paths = {
  LANDING_PAGE: '/',
  AGENT_BUILDER: '/agent-builder',
  MANAGE_AGENTS: '/manage-agents',
  RUN_AGENT: '/run-agent'
};

// Agent Builder
export const AgentBuilderPaths = {
  CREATE_AGENT: `${Paths.AGENT_BUILDER}/automated-agents/create`,
  EDIT_AGENT: `${Paths.AGENT_BUILDER}/automated-agents/:agentInstanceId/edit`
};
export const AgentSubAgentPaths = {
  CREATE_AGENT_SUB_AGENT: `${AgentBuilderPaths.CREATE_AGENT}/sub-agents`,
  CREATE_AGENT_SUB_AGENT_DETAILS: `${AgentBuilderPaths.CREATE_AGENT}/sub-agents/:subAgentInstanceId`,
  EDIT_AGENT_SUB_AGENT: `${AgentBuilderPaths.EDIT_AGENT}/sub-agents`,
  EDIT_AGENT_SUB_AGENT_DETAILS: `${AgentBuilderPaths.EDIT_AGENT}/sub-agents/:subAgentInstanceId`
};
export const AgentToolsPaths = {
  CREATE_AGENT_TOOLS: `${AgentBuilderPaths.CREATE_AGENT}/tools`,
  CREATE_AGENT_TOOL_DETAILS: `${AgentBuilderPaths.CREATE_AGENT}/tools/:toolId`,
  EDIT_AGENT_TOOLS: `${AgentBuilderPaths.EDIT_AGENT}/tools`,
  EDIT_AGENT_TOOL_DETAILS: `${AgentBuilderPaths.EDIT_AGENT}/tools/:toolId`
};
export const AgentMcpPaths = {
  CREATE_AGENT_MCP: `${AgentBuilderPaths.CREATE_AGENT}/mcp`,
  CREATE_AGENT_MCP_DETAILS: `${AgentBuilderPaths.CREATE_AGENT}/mcp/:authenticatorId`,
  EDIT_AGENT_MCP: `${AgentBuilderPaths.EDIT_AGENT}/mcp`,
  EDIT_AGENT_MCP_DETAILS: `${AgentBuilderPaths.EDIT_AGENT}/mcp/:authenticatorId`
};
export const AgentKnowledgePaths = {
  CREATE_AGENT_KNOWLEDGE: `${AgentBuilderPaths.CREATE_AGENT}/knowledge`,
  CREATE_AGENT_KNOWLEDGE_VAULT_DETAILS: `${AgentBuilderPaths.CREATE_AGENT}/knowledge/:vaultId`,
  EDIT_AGENT_KNOWLEDGE: `${AgentBuilderPaths.EDIT_AGENT}/knowledge`,
  EDIT_AGENT_KNOWLEDGE_VAULT_DETAILS: `${AgentBuilderPaths.EDIT_AGENT}/knowledge/:vaultId`
};
export const AgentUserInputsPaths = {
  CREATE_AGENT_USER_INPUTS: `${AgentBuilderPaths.CREATE_AGENT}/user-inputs`,
  EDIT_AGENT_USER_INPUTS: `${AgentBuilderPaths.EDIT_AGENT}/user-inputs`
};
export const AgentAccessPaths = {
  CREATE_AGENT_ACCESS: `${AgentBuilderPaths.CREATE_AGENT}/access`,
  EDIT_AGENT_ACCESS: `${AgentBuilderPaths.EDIT_AGENT}/access`
};
export const AgentNotificationsPaths = {
  EDIT_AGENT_NOTIFICATIONS: `${AgentBuilderPaths.EDIT_AGENT}/notifications`
};

// Assistant Builder
export const AssistantBuilderPaths = {
  CREATE_ASSISTANT: `${Paths.AGENT_BUILDER}/assistants/create`,
  EDIT_ASSISTANT: `${Paths.AGENT_BUILDER}/assistants/:assistantId/edit`
};
export const AssistantKnowledgePaths = {
  CREATE_ASSISTANT_KNOWLEDGE: `${AssistantBuilderPaths.CREATE_ASSISTANT}/knowledge`,
  CREATE_ASSISTANT_KNOWLEDGE_VAULT_DETAILS: `${AssistantBuilderPaths.CREATE_ASSISTANT}/knowledge/:vaultId`,
  EDIT_ASSISTANT_KNOWLEDGE: `${AssistantBuilderPaths.EDIT_ASSISTANT}/knowledge`,
  EDIT_ASSISTANT_KNOWLEDGE_VAULT_DETAILS: `${AssistantBuilderPaths.EDIT_ASSISTANT}/knowledge/:vaultId`
};
export const AssistantAccessPaths = {
  CREATE_ASSISTANT_ACCESS: `${AssistantBuilderPaths.CREATE_ASSISTANT}/access`,
  EDIT_ASSISTANT_ACCESS: `${AssistantBuilderPaths.EDIT_ASSISTANT}/access`
};

// Manage
export const ManagePaths = {
  INTRO: `${Paths.MANAGE_AGENTS}/intro`,
  AGENTS: `${Paths.MANAGE_AGENTS}/agents`,
  ASSISTANTS: `${Paths.MANAGE_AGENTS}/assistants`,
  INBOX: `${Paths.MANAGE_AGENTS}/inbox`,
  AUTOMATIONS: `${Paths.MANAGE_AGENTS}/automations`,
  NEEDS_ATTENTION: `${Paths.MANAGE_AGENTS}/needs-attention`
};

// Run Agent
export const RunAgentPaths = {
  RUN_AGENT: `${Paths.RUN_AGENT}/:agentInstanceId`
};
export const RunExecutionPaths = {
  RUN_EXECUTION: `${RunAgentPaths.RUN_AGENT}/:executionId`
};
export const RenderOutputPaths = {
  RENDER_OUTPUT: '/render-output/:agentInstanceId/:executionId/:outputIndex'
};
export const RenderOutputPathsWithType = {
  RENDER_OUTPUT_WITH_TYPE: '/render-output/:agentInstanceId/:executionId/:outputIndex/:outputType'
};